import React from "react";
import styled from "styled-components";
import {
  Container,
  Logo,
  BasicText,
  Heading,
  CodeView,
  CodeOuter
} from "../styles";

class GettingStarted extends React.Component {
  render() {
    return (
      <Container>
        <Heading>Getting Started</Heading>
        <BasicText style={{ marginBottom: "30px" }}>
          To get started , navigate to your project folder in terminal and type
          :
        </BasicText>

        <CodeOuter>
          <CodeView>npm install react-native-normalized --save</CodeView>
        </CodeOuter>

        <BasicText style={{ marginTop: "20px" }}>
          and you are ready to go !
        </BasicText>

        <BasicText style={{ marginTop: "30px" }}>
          Now you can use any normalized components from the library! Here is an
          Example:
        </BasicText>
        <CodeOuter>
          <CodeView>
            {
              "import React from 'react';\r\nimport { View } from 'react-native';\r\nimport { Text } from 'react-native-normalized';\r\n\r\n\r\nclass Example extends React.Component {\r\n  render(){\r\n   return(\r\n     <View>\r\n        <Text> Im Normalized </Text>\r\n      </View>\r\n    )\r\n  }\r\n}"
            }
          </CodeView>
        </CodeOuter>
      </Container>
    );
  }
}

export default GettingStarted;
